<template>
    <div class="season-fields">
        <div class="mb-3">
            <label class="form-label" for="season-name">Nombre</label>
            <input id="season-name" type="text" class="form-control" v-model="model.name" :placeholder="'Ej. Vuelta a España 2026'">
        </div>
        <div class="row g-3 mb-3">
            <div class="col-md-4">
                <label class="form-label" for="season-pre">Abre la inscripción</label>
                <input id="season-pre" type="datetime-local" class="form-control" v-model="model.pre_start_date">
            </div>
            <div class="col-md-4">
                <label class="form-label" for="season-start">Empieza</label>
                <input id="season-start" type="datetime-local" class="form-control" v-model="model.start_date">
            </div>
            <div class="col-md-4">
                <label class="form-label" for="season-end">Termina</label>
                <input id="season-end" type="datetime-local" class="form-control" v-model="model.end_date">
            </div>
            <div class="col-12 form-text mt-1">Desde que abre la inscripción los equipos ya pueden registrarse, aunque todavía no haya empezado.</div>
        </div>
        <div class="row g-3">
            <div class="col-md-4">
                <label class="form-label" for="season-score">Puntos por acierto</label>
                <input id="season-score" type="number" step="0.1" min="0" class="form-control" v-model="model.base_score">
                <div class="form-text">Lo usan los rankings de tipo "Puntuación base".</div>
            </div>
            <div class="col-md-8">
                <label class="form-label">Tema visual</label>
                <div class="theme-options">
                    <label v-for="theme in themes" :key="theme.id" class="theme-option" :class="{ 'is-selected': model.theme == theme.id }">
                        <input type="radio" class="visually-hidden" :value="theme.id" v-model="model.theme">
                        <span class="theme-rider"><component :is="theme.rider" color="#00a7af" :size="40" /></span>
                        <span>{{ theme.label }}</span>
                    </label>
                </div>
                <div class="form-text">El personaje de la barra de progreso y de las animaciones, y sus textos (salida, meta, paradas).</div>
            </div>
        </div>
    </div>
</template>

<script>
import { theme_list } from '@/themes'

// Editable fields of a season/event, bound to a plain working copy (see
// to_datetime_local in utils/admin-format.js for the date inputs). Used by
// the "new event" modal and the event's Configuración page.
export default {
    name: 'SeasonFields',
    props: {
        model: { type: Object, required: true },
    },
    data(){
        return { themes: theme_list() };
    }
}
</script>

<style scoped>
.theme-options{ display: flex; gap: 8px; flex-wrap: wrap; }
.theme-option{
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 12px 6px 6px;
    border: 1px solid var(--a-line-strong);
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 0.85rem;
    background: var(--a-surface);
}
.theme-option.is-selected{
    border-color: var(--a-accent);
    box-shadow: 0 0 0 2px var(--a-accent-soft);
}
.theme-rider{
    width: 52px;
    height: 36px;
    border-radius: 6px;
    background: var(--a-ink);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 4px;
}
</style>
